import React, { useEffect, useRef } from "react";
import {
  UserCheck,
  Calendar,
  Users,
  User,
  FileText,
  Activity,
  Database,
  DollarSign,
  Box,
  BarChart2,
} from "react-feather";

const topFeatures = [
  { icon: UserCheck, title: "Patient Management" },
  { icon: Calendar, title: "Appointment Scheduling" },
  { icon: User, title: "Doctor Management" },
  { icon: Users, title: "Staff Management" },
  { icon: FileText, title: "Electronic Medical Records (EMR)" },
];

const bottomFeatures = [
  { icon: Activity, title: "Pharmacy Management" },
  { icon: Database, title: "Laboratory Management" },
  { icon: DollarSign, title: "Billing & Accounting" },
  { icon: Box, title: "Inventory Management" },
  { icon: BarChart2, title: "Reports & Analytics" },
];

const ModulesSection = () => {
  const topRef = useRef(null);
  const bottomRef = useRef(null);

  useEffect(() => {
    let topX = 0;
    let bottomX = 0;

    const animate = () => {
      // TOP → LEFT
      topX -= 0.3;
      if (Math.abs(topX) >= topRef.current.scrollWidth / 2) {
        topX = 0;
      }
      topRef.current.style.transform = `translateX(${topX}px)`;

      // BOTTOM → RIGHT
      bottomX += 0.3;
      if (bottomX >= bottomRef.current.scrollWidth / 2) {
        bottomX = 0;
      }
      bottomRef.current.style.transform = `translateX(${bottomX}px)`;

      requestAnimationFrame(animate);
    };

    requestAnimationFrame(animate);
  }, []);

  const renderItems = (features) =>
    [...features, ...features].map((item, index) => {
      const Icon = item.icon;
      return (
        <div key={index} className="col-6 col-lg-2 flex-shrink-0 px-2">
          <div className="bg-light rounded shadow-sm p-3 h-100 d-flex flex-column align-items-center justify-content-center text-center">
            <Icon
              size={40}
              className="mb-2 white-text lanp-bg-primary  p-2 rounded-circle"
            />
            <h6 className="fw-semibold mb-0 text-dark">
              {item.title}
            </h6>
          </div>
        </div>
      );
    });

  return (
    <section className=" lanp-bg-secondary py-5" id='solutions'>
      <div className="container">

        <div className="text-center mb-4" data-aos="zoom-in">
          <h2 className="fw-bold fs-1 text-white">
             Hospital Management Software  <span className="text-white">Modules</span>
          </h2>
          <p className="text-white mb-0">
            Complete hospital management system features
          </p>
        </div>

        {/* TOP */}
        <div className="overflow-hidden">
          <div ref={topRef} className="d-flex modules-track">
            {renderItems(topFeatures)}
          </div>
        </div>

        {/* BOTTOM */}
        <div className="overflow-hidden mt-3">
          <div ref={bottomRef} className="d-flex modules-track">
            {renderItems(bottomFeatures)}
          </div>
        </div>

      </div>
    </section>
  );
};

export default ModulesSection;